/**
 * Optimize Cloudinary image URLs with delivery transformations.
 * Inserts f_auto (webp/avif), q_auto, and optional width into the URL.
 * Non-Cloudinary URLs are returned unchanged.
 */

const CLOUDINARY_BASE = "res.cloudinary.com";

function addTransforms(url, transforms) {
  if (!url || !url.includes(CLOUDINARY_BASE)) return url;
  // Insert transforms after /upload/
  return url.replace("/upload/", `/upload/${transforms}/`);
}

/** Full-size image — auto format + auto quality, capped at 1200px (post detail view) */
export function optimizedUrl(url) {
  return addTransforms(url, "f_auto,q_auto,w_1200,c_limit");
}

/** Thumbnail — auto format + quality + capped width (map pins, profiles, popups) */
export function thumbnailUrl(url, width = 400) {
  return addTransforms(url, `f_auto,q_auto,w_${width},c_limit`);
}
